"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _construct2 = _interopRequireDefault(require("@babel/runtime/helpers/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _sync = _interopRequireDefault(require("./sync.xhr"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _default =
/*#__PURE__*/
function () {
  function _default() {
    (0, _classCallCheck2["default"])(this, _default);
    (0, _defineProperty2["default"])(this, "pollInterval", 2000);
    this._listeners = {};
    this._xhrSyncInstance = new _sync["default"]();
    return this;
  }

  (0, _createClass2["default"])(_default, [{
    key: "query",
    value: function query() {
      var _this = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var method = arguments.length > 1 ? arguments[1] : undefined;
      var storage = arguments.length > 2 ? arguments[2] : undefined;
      var id;
      this.stopListening(storage);
      storage._syncListenerId = id = options.listenerId || (0, _uniqueId["default"])('ddos_listener');
      this._listeners[id] = {};
      this.poolXHR = this._makeQuery(options, method, storage); // run default sync with interval

      this._listeners[id].intervalId = setInterval(function () {
        // replace listener sync on default sync
        _this.poolXHR = _this._makeQuery(options, method, storage);
      }, options.pollInterval || this.pollInterval);

      if (options.pollTimeout !== undefined) {
        // stop polling on timeout
        this._listeners[id].timeoutId = setTimeout(function () {
          _this.stopListening(storage);

          if (typeof options.error === 'function') {
            options.error({
              message: 'timeout'
            });
          }

          if (typeof options.complete === 'function') {
            options.complete();
          }
        }, options.pollTimeout);
      } // reference to sync, needed for stopListening


      storage.ddosSync = this;
    }
    /**
     * stop listening storage
     * @param {object} storage
     * @return {object}
     */

  }, {
    key: "stopListening",
    value: function stopListening(storage) {
      if (storage._syncListenerId && this._listeners[storage._syncListenerId]) {
        clearInterval(this._listeners[storage._syncListenerId].intervalId);
        clearTimeout(this._listeners[storage._syncListenerId].timeoutId);
        delete this._listeners[storage._syncListenerId];
        this.poolXHR && this.poolXHR.abort();
      }

      return this;
    }
  }, {
    key: "_makeQuery",
    value: function _makeQuery() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var method = arguments.length > 1 ? arguments[1] : undefined;
      var storage = arguments.length > 2 ? arguments[2] : undefined;
      var beforeSend = options.beforeSend,
          complete = options.complete;

      if (!storage._sync_listener_active_pool) {
        options.beforeSend = function (jqXHR) {
          storage._sync_listener_active_pool = true;

          if (typeof beforeSend === 'function') {
            return beforeSend(jqXHR);
          }
        };

        options.complete = function (jqXHR) {
          storage._sync_listener_active_pool = false;

          if (typeof complete === 'function') {
            return complete(jqXHR);
          }
        };

        return this._xhrSyncInstance.query(options, method, storage);
      } else {
        return this.poolXHR;
      }
    }
    /**
     * @return {object} singleton of this class
     */

  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!this.prototype.singletonInstance) {
        var parent = this,
            Surrogate;

        Surrogate = function Surrogate() {
          var _parent$prototype$con;

          for (var _len2 = arguments.length, rest = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            rest[_key2] = arguments[_key2];
          }

          // для того что бы принимать динамическое к-во аргументов в конструктор
          return (_parent$prototype$con = parent.prototype.constructor).call.apply(_parent$prototype$con, [this].concat(rest));
        };

        Surrogate.prototype = parent.prototype;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        this.prototype.singletonInstance = (0, _construct2["default"])(Surrogate, args);
      }

      return this.prototype.singletonInstance;
    }
  }]);
  return _default;
}();

exports["default"] = _default;